import  request  from '../request'
/* ********************** 登录 ************************** */
// 获取登录短信验证码
// export function getVeriCode (mobile) {
//   return request({
//     url: '/official-website/mgnt/auth/loginByPhoneSms',
//     data: mobile,
//     method: 'post'
//   })
// }
// 登录
export function login (data) {
  return request({
    url: '/official-website/mgnt/auth/loginByPhoneSms',
    data,
    method: 'post'
  })
}

/* ********************** 拿到首页视频列表列表 ************************** */
export function getProductList () {
  return request({
    url: '/official-website/video/admin/list',
    params: {},
    method: 'get'
  })
}
/* ********************** 视频修改 ************************** */
export function updateVideoId (data) {
  return request({
    url: '/official-website/video/admin/update',
    data,
    method: 'put'
  })
}
/* ********************** 拿到首页视频Url ************************** */
export function getVideoUrl (productId) {
  return request({
    url: '/official-website/video/getPlayInfo/' + productId,
    params: {},
    method: 'get'
  })
}
/* ********************** 拿到产品下的系统管理 ************************** */
export function getProductTableList (productId, {current, size, keywords}) {
  return request({
    url: '/official-website/system/admin/pageList/' + productId,
    params: {
      current, 
      size, 
      keywords
    }
  })
}
/* ********************** 拿到招聘列表(全部) ************************** */
export function getJobAllList () {
  return request({
    url: '/official-website/employment/list',
    method: 'get'
  })
}
/* ********************** 拿到搜索招聘列表(全部) ************************** */
export function getJobSearch (keywords) {
  return request({
    url: '/official-website/employment/search',
    params: {
      keywords
    },
    method: 'get'
  })
}
/* ********************** 招聘启停 ************************** */
export function changeOneJobStatus (employmentId, status) {
  return request({
    url: '/official-website/employment/admin/isDisabled?employmentId=' + employmentId + '&status=' + status,
    method: 'put'
  })
}
/* ********************** 系统更新排序 ************************** */
export function updateSystemSort (data) {
  return request({
    url: '/official-website/system/admin/updateSort',
    data,
    method: 'put'
  })
}
/* ********************** 案例更新排序 ************************** */
export function updateCaseSort (data) {
  return request({
    url: '/official-website/sysCase/admin/updateSort',
    data,
    method: 'put'
  })
}
/* ********************** 拿到产品下的案例管理 ************************** */
export function getCaseTableList (productId, {current, size, keywords}) {
  return request({
    url: '/official-website/sysCase/pageList/' + productId,
    params: {
      current, 
      size,
      keywords
    },
    method: 'get'
  })
}
/* ********************** 添加系统信息 ************************** */
  export function addSystemMsg (data) {
    return request({
      url: '/official-website/system/admin/add',
      data,
      method: 'post'
    })
  }
  /* ********************** 编辑系统信息 ************************** */
  export function editSystemMsg (data) {
    return request({
      url: '/official-website/system/admin/update',
      data,
      method: 'put'
    })
  }
/* ********************** 删除系统信息 ************************** */
  export function delSystemMsg (sysId) {
    return request({
      url: '/official-website/system/admin/del/' + sysId,
      method: 'delete'
    })
  }
  // /* ********************** 修改系统信息状态 ************************** */
  export function changeOneSystemStatus (sysId, status) {
    return request({
      url: '/official-website/system/admin/isDisabled?sysId=' + sysId + '&status=' + status,
      method: 'put'
    })
  }
  // /* ********************** 修改案例状态 ************************** */
  export function changeOneCaseStatus (caseId, status) {
    return request({
      url: '/official-website/sysCase/admin/isDisabled?caseId=' + caseId + '&status=' + status,
      method: 'put'
    })
  }
/* ********************** 拿到案例下的系统管理 ************************** */
export function getCaseTableMsgList (productId) {
  return request({
    url: '/official-website/sysCase/pageList/' + productId,
    params: {},
    method: 'get'
  })
}
/* ********************** 添加应用案例 ************************** */
export function caseAddSave (data) {
  return request({
    url: '/official-website/sysCase/admin/add',
    data,
    method: 'post'
  })
}
/* ********************** 删除应用案例 ************************** */
export function caseDelOne (caseId) {
  return request({
    url: '/official-website/sysCase/admin/del/' + caseId,
    method: 'delete'
  })
}
/* ********************** 修改案例 ************************** */
export function caseEditSave (data) {
  return request({
    url: '/official-website/sysCase/admin/update',
    data,
    method: 'put'
  })
}
/* ********************** 拿到招聘列表 ************************** */
export function getJobList ({current, size, keywords}) {
    return request({
      url: '/official-website/employment/admin/pageList',
      params: {
        current,
        size,
        keywords
      },
      method: 'get'
    })
  }
/* ********************** 拿到职位字典表 ************************** */
  export function getJobWords ( dictType ) {
    return request({
      url: '/official-website/dict-data/get/' + dictType,
      method: 'get'
    })
  }
/* ********************** 招聘信息详情 ************************** */
  export function getEmploymentDetails ( employmentId ) {
    return request({
      url: '/official-website/employment/admin/detail/' + employmentId,
      method: 'get'
    })
  }
/* ********************** 更新招聘信息 ************************** */
  export function updateDetails (data) {
    return request({
      url: '/official-website/employment/admin/update',
      data,
      method: 'put'
    })
  }
  /* ********************** 发布新招聘信息 ************************** */
  export function onNewJobSubmit (data) {
    return request({
      url: '/official-website/employment/admin/add',
      data,
      method: 'post'
    })
  }
  /* ********************** 删除一条招聘信息 ************************** */
  export function deleteOne (employmentId) {
    return request({
      url: '/official-website/employment/admin/del/' + employmentId,
      method: 'delete'
    })
  }
    /* ********************** 获取这条新闻详情 ************************** */
    export function getNewsDetai (newsId) {
      return request({
        url: '/official-website/news/detail/' + newsId,
        method: 'get'
      })
    }
    /* ********************** 获取新闻列表 ************************** */
    export function getNewsList ({current, size}) {
      return request({
        url: '/official-website/news/admin/pageList',
        params: {
          current,
          size
        },
        method: 'get'
      })
    }
    /* ********************** 新闻启停 ************************** */
    export function changeNewsStatus (newsId, status) {
      return request({
        url: '/official-website/news/admin/isDisabled?newsId=' + newsId + '&status=' + status,
        method: 'put'
      })
    }
/* ********************** 修改新闻 ************************** */
  export function updateNews (data) {
    return request({
      url: '/official-website/news/admin/update',
      data,
      method: 'put'
    })
  }
  /* ********************** 新增新闻 ************************** */
  export function addNews (data) {
    return request({
      url: '/official-website/news/admin/add',
      data,
      method: 'post'
    })
  }
  /* ********************** 删除一条新闻 ************************** */
  export function deleteOneNews (newsId) {
    return request({
      url: '/official-website/news/admin/del/' + newsId,
      method: 'delete'
    })
  }
  /* ********************** 拿到关于我们荣誉列表 ************************** */
export function getHonorList ({current, size, honorTypeId}) {
  return request({
    url: '/official-website/honor/admin/pageList/',
    params: {
      current,
      size,
      honorTypeId
    },
    method: 'get'
  })
}
  /* ********************** 删除一条荣誉记录 ************************** */
  export function deleteAboutUsOne (honorId) {
    return request({
      url: '/official-website/honor/admin/del/' + honorId,
      method: 'delete'
    })
  }
  /* ********************** 荣誉状态启停 ************************** */
  export function changeOneHonorStatus (honorId, status) {
    return request({
      url: '/official-website/honor/admin/isDisabled?honorId=' + honorId + '&status=' + status,
      method: 'put'
    })
  }
  /* **********************关于我们-信息发布  ************************** */
  export function aboutUsAdd (data) {
    return request({
      url: '/official-website/honor/admin/add',
      data,
      method: 'post'
    })
  }
  /* ********************** 关于我们-修改 ************************** */
  export function updateAbout (data) {
    return request({
      url: '/official-website/honor/admin/update',
      data,
      method: 'put'
    })
  }
    /* ********************** 客户意向-获取客户意向信息列表 ************************** */
export function getIntentionList ({begin, end, current, size, intentionProductId}) {
  return request({
    url: '/official-website/intention/admin/pageList',
    params: {
      begin,
      end,
      current,
      size,
      intentionProductId
    },
    method: 'get'
  })
}
  /* ********************** 客户意向-根据id获取客户意向详情 ************************** */
  export function getIntentionDetail (intentionId) {
    return request({
      url: '/official-website/intention/admin/get/' + intentionId,
      method: 'get'
    })
  }
  /* **********************意向信息-导出  ************************** */
  export function exportIntentionList ({begin, end, intentionProductId}) {
    return request({
      url: '/official-website/intention/admin/export',
      method: 'get',
      responseType: 'blob',
      params: {
        begin,
        end,
        intentionProductId
      },
    })
  }
  /* ********************** 获取地图列表 ************************** */
  export function getMapbList ({current, size, keywords}) {
    return request({
      url: '/official-website/site/admin/pageList',
      params: {
        current,
        size,
        keywords
      },
      method: 'get'
    })
  }
  /* ********************** 更新点位 ************************** */
  export function mapPointAdd (data) {
    return request({
      url: '/official-website/site/admin/add',
      data,
      method: 'post'
    })
  }
  /* ********************** 删除一条荣誉记录 ************************** */
  export function deleteMapSite (siteId) {
    return request({
      url: '/official-website/site/admin/del/' + siteId,
      method: 'delete'
    })
  }
  // /* ********************** 获取视频 ************************** */
  // export function getVideoUrl (data) {
  //   return request({
  //     url: '/official-website/video/getPlayInfo/' + data,
  //     method: 'get'
  //   })
  // }
  /* ********************** 获取视频播放链接 ************************** */
  export function getVideoPlayInfo (data) {
    return request({
      url: '/official-website/video/getPlayInfo/' + data,
      method: 'get'
    })
  }
   /* ********************** 获取地图各产线项目列表 ************************** */
   export function getMapMarkers (data) {
    return request({
      url: '/official-website/site/search',
      method: 'get',
      params:data
    })
  }
  /* ********************** 修改点位信息 ************************** */
  export function updateSiteMsg (data) {
    return request({
      url: '/official-website/site/admin/update',
      data,
      method: 'put'
    })
  }
  export function reload () {
    return request({
      url: '/official-website/user/reload',
      method: 'get'
    })
  }

    /* ********************** 获取申请试用列表 ************************** */
    export function getApplyUseList (data) {
      return request({
        url: '/official-website/admin/trial/pageList',
        method: 'get',
        params:data
      })
    }
    export function exportApplyUseList ({address, startTime, endTime, mobile}) {
      return request({
        url: '/official-website/admin/trial/export',
        method: 'get',
        responseType: 'blob',
        params: {
          address,
          startTime,
          endTime,
          mobile
        },
      })
    }


// WEBPACK FOOTER //
// ./src/api/website/website.js